export enum ThirdPartyRefundProvider {
  Refundid = "refundid",
  Paypal = "paypal",
  Venmo = "venmo",
}
